<div class="app-body tw-relative">
  <div class="header">
    <a class="logo" routerLink="/admin-redirect">
      <img [src]="store.brandMeta()?.logoInverted" [alt]="store.brandMeta()?.shortName" />
    </a>
    <div class="navmenu">
      <div ngbDropdown class="d-inline-block">
        <button id="ngb-usermenu" class="navitem user-avatar-header !tw-pr-1" ngbDropdownToggle>
          <span class="tw-text-black">{{ partnerStore.userInfo()?.name?.slice(0, 2) }}</span>
          <p>
            {{ partnerStore.userInfo()?.name }}
          </p>

          <i class="gg-chevron-down"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="ngb-usermenu" class="dropmenu">
          <div class="dropitem group user-info">
            <div class="user-avatar">
              <span>{{ partnerStore.userInfo()?.name?.slice(0, 2) }}</span>
            </div>
            <div class="user-details">
              <div class="tw-font-semibold">{{ partnerStore.userInfo()?.name }}</div>
              <div class="help-text ellipsis">
                {{ partnerStore.userInfo()?.email }}
              </div>
            </div>
          </div>
          <button class="dropitem group flex-apart tw-border-b" (click)="openModal(changePassword, 'md')">
            <div class="tw-text-left tw-flex tw-items-center tw-gap-4">
              <ng-icon name="matLockOutline" /> Change Password
            </div>
          </button>

          <button class="dropitem group tw-border-0 text-danger" (click)="partnerStore.clearSession()">
            <ng-icon name="matPowerSettingsNewOutline" /> Logout
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="tw-flex tw-relative">
    @if (!store.sideNavHide()) {
      <app-sidenav [app]="{ name: 'Partner', icon: 'matHandshakeOutline' }" [menu]="sidenavMenu" [search]="false" />
    }
    <div
      class="tw-flex-1 tw-min-w-0 page-wrapper"
      [class]="{
        'tw-bg-white': hasWhiteBg(),
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>

  <ng-template #changePassword>
    <app-change-password (closeEvent)="closeModal()" />
  </ng-template>
</div>
